import { FontSizes } from "@fluentui/theme";

export const TextFont24 = {
    fontSize: FontSizes.size14,
    display: "inline",
    fontStyle: "normal"
};

export const TextFont18 = {
    fontSize: FontSizes.size18,
    display: "inline",
    fontStyle: "normal",
    fontWeight: 'bold'
};

export const CardLayoutStyle = {
    layout: {
        margin: 0,
        padding: 0,
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "30px",
        paddingRight: "30px",
        // borderBottom: "2px solid lightgrey",
      },
}